import Base from "./base";

export default class TrendCard extends Base {
    makeExternalPayment(newStep) {
        const { stake } = this.state;
        this.props.externalFunc.makeDeposit({
            type: "card",
            amount: stake,
            claimsBonus: false,
        }, (data) => {
            this.setState({
                externalUrl: data.url,
                currentStep: newStep
            })
        });
    }

    makeExternalPaymentWithBonus(newStep, bonusId) {
        const { stake } = this.state;
        this.props.externalFunc.makeDeposit({
            type: "card",
            amount: stake,
            claimsBonus: true,
            bonusId: bonusId
        }, (data) => {
            this.setState({
                externalUrl: data.url,
                currentStep: newStep
            })
        });
    }
}
